import { useRef } from "react";
import{ sentence } from "shared/types/Report";
import useView from "./useView";
import useStorage from "shared/hooks/useStorage";


const useSentenceView = (list:sentence[], setList:React.Dispatch<React.SetStateAction<sentence[]>>, path:string) => {
    const {uploadStorage, deleteStorage} = useStorage();
    const baseHook = useView(list, setList, path);
    const imageInputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const audioInputRefs = useRef<Array<HTMLInputElement | null>>([]);

    const onAddClickHandler = () => {
        setList(prev => [...prev, {
            id:prev.length ? prev[prev.length -1].id + 1 : 1,
            sentence:"",
            kor:"",
            image:"",
            audio:""
        }])
    }

    const onAudioInputClickHandler = (index: number) => {
        const inputElement = audioInputRefs.current[index];
        if(inputElement){
            inputElement.click()
        }else{
            console.error(`Input element at index ${index} is null`);
        }
    }

    const onImageInputClickHandler = (index: number) => {
        const inputElement = imageInputRefs.current[index];
        if (inputElement) {
          inputElement.click();
        } else {
          console.error(`Input element at index ${index} is null`);
        }
    };

    const onAudioChangeHandler = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if(file){
            const newList = list.map((item, idx) => {
                const fileURL = URL.createObjectURL(file);
                if (idx === index) {
                return { ...item, audio:fileURL};
                }
                return item;
            });
            setList(newList);
        }
    }

    

    const onImageChangeHandler = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                updateItemImage(index, reader.result as string, file);
            };
            reader.readAsDataURL(file);
        }
    };

    const updateItemImage = (index: number, imageUrl: string, file:File) => {
        const newList = list.map((item, idx) => {
            if (idx === index) {
            return { ...item, image_preview: imageUrl, image:file};
            }
            return item;
        });
        setList(newList);
    };


    const onRegisterReportClickHandler = async() => {
        const data = await registerImage();
        const audio = await registerAudio(data);
        const register_data = baseHook.removeKeyFromObjects(audio, "image_preview");
        baseHook.onRegisterReportClick("sentence", register_data);
    }

    const registerImage = async() => {
        let sentenceList = list;
        let prevImageUrl = null;
        baseHook.setShowProgress(true);
        for(let i = 0; i < list.length; i++){
            const image = list[i].image;
            if (image instanceof File) {
                baseHook.setUploadFileName(image.name);
                const image_url = await uploadStorage(path + "/sentence", image, baseHook.setProgress).then(res => {
                    return res || "";
                })
                sentenceList[i].image = image_url;
                prevImageUrl = image_url;
            }
            if(!image && prevImageUrl){
                sentenceList[i].image = prevImageUrl;
            }
        }
        baseHook.setShowProgress(false);
        return sentenceList;
    }

    const registerAudio = async (list:sentence[]) => {
        let sentenceList = list;
        baseHook.setShowProgress(true);
      
        for (let i = 0; i < list.length; i++) {
          const audio = list[i].audio;
      
          if (audio) {
            let file;
            try {
              // audio가 string인 경우에만 fetch를 사용하여 Blob으로 변환
              if (typeof audio === "string") {
                const response = await fetch(audio);
                const blob = await response.blob();
                file = new File([blob], `audio-${i}.mp3`, {
                  type: blob.type,
                  lastModified: Date.now(),
                });
              }
              // 업로드 처리
              baseHook.setUploadFileName(`audio-${i}.mp3`);
              if(file){
                const audio_url = await uploadStorage(
                    path + "/sentence",
                    file,
                    baseHook.setProgress
                  ).then((res) => {
                    return res || "";
                  });
                  sentenceList[i].audio = audio_url;
              }
            } catch (error) {
              console.error("오디오 처리 중 오류 발생:", error);
            }
          }
        }
      
        baseHook.setShowProgress(false);
        return sentenceList;
      };

    const onDeleteImageClickHandler = () => {
        const newList = list.map((item, idx) => {
            if (idx === baseHook.selectedFile.index) {
            return { ...item, image_preview:"", image:null};
            }
            return item;
        });
        if(baseHook.selectedFile.url.includes("https")){
            deleteStorage(path + "/sentence", baseHook.selectedFile.url);
            const register_data = baseHook.removeKeyFromObjects(newList, "image_preview");
            baseHook.onRegisterReportClick("sentence", register_data);
        }
        setList(newList);
    }
    
    const onAudioDeleteHandler = (index: number) => {
        const newList = list.map((item, idx) => {
            if (idx === index) {
                return { ...item, audio: "" };
            }
            return item;
        });
        setList(newList);
    }

    return {...baseHook, onAddClickHandler, onRegisterReportClickHandler, imageInputRefs, onImageInputClickHandler, onImageChangeHandler, onDeleteImageClickHandler, audioInputRefs, onAudioInputClickHandler, onAudioChangeHandler, onAudioDeleteHandler}
}

export default useSentenceView;